import { useState } from 'react';
import Helmet from 'react-helmet';

import { useGlobalAuthStore } from '@Stores/global/auth';
import history from '@Utils/history';

import Form from '../components/LoginForm';

export default function LoginFormLayout() {
  const { auth: { login, verifyLogin, error, onChangeError } } = useGlobalAuthStore()
  const [data, setData] = useState(false)

  async function handleSubmit(payload, step) {
    if (step === 'login') {
      const data = await login(payload)
      data && setData(data)
      if (data && data.twoFactorRequired) return;
    }

    if (step === 'verifyLogin') {
      await verifyLogin(payload)
    }

    history.push('/auth/site_selection')
  }

  return <div>
    <Helmet title="Login" />
    <Form data={data} handleSubmit={handleSubmit} error={error} onChangeError={onChangeError} />
  </div>
}

